export default __webpack_public_path__ + "media/color/zec-322df4aa.svg";